import { useNavigate } from "react-router";
import { useTrackerEvents } from "@/queries/tracker/useTrackerEvents";
import { Button } from "./Button";
import LoadingSection from "./LoadingSection";
import Event from "@/panel/dashboard/progress/Event";
import { mapTrackerEventToEventExample } from "@/panel/dashboard/progress/Progress";

type Props = {
  maxEvents?: number;
};

export const TrackerView = ({ maxEvents }: Props) => {
  const navigate = useNavigate();
  const {
    data: allTrackerEventsOptional,
    isLoading,
  } = useTrackerEvents();

  const allTrackerEvents = allTrackerEventsOptional || [];

  const overflow =
    maxEvents !== undefined && allTrackerEvents.length > maxEvents;

  const trackerEvents = overflow
    ? allTrackerEvents.slice(0, maxEvents)
    : allTrackerEvents;

  const events = trackerEvents.map(mapTrackerEventToEventExample);

  if (isLoading) {
    return <LoadingSection />;
  }

  if (!allTrackerEvents || allTrackerEvents.length === 0) {
    return (
      <div className="min-h-40 sm:min-h-72 flex items-center justify-center">
        <p className="text-white/80">No events in the tracker.</p>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col">
      <div className="w-full flex flex-col">
        {events.map((event, index) => (
          <Event
            key={event.uuid || index}
            event={event}
            isFirst={index === 0}
            isLast={index === events.length - 1}
          />
        ))}
      </div>
      {overflow && (
        <div className="flex justify-center mt-6">
          <Button text="more" onClick={() => navigate("/dashboard/tracker")} />
        </div>
      )}
    </div>
  );
};

